/** Internal only symbol used by `Form` & `ObjectField` to mark an additional property element to be removed */
export const ADDITIONAL_PROPERTY_KEY_REMOVE = Symbol('remove-this-key');

/** Internal only symbol used by the `reset()` function to indicate that a reset operation is happening */
export const IS_RESET = Symbol('reset');
